import { render, staticRenderFns } from "./Recorrido.vue?vue&type=template&id=0812a519&"
import script from "./Recorrido.vue?vue&type=script&lang=ts&"
export * from "./Recorrido.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports